import React from 'react'
import { CircleMarker, Polyline, Polygon, LayerGroup, Tooltip } from 'react-leaflet'

import './PolygonSelectionLayer.css'

const PolygonLayer = ({ polygon, active }) =>
    polygon && polygon.length ? (
        <Polygon className={active ? 'polygon active' : 'polygon'} positions={polygon} interactive={false} />
    ) : null

const getStatusText = polygon => {
    switch (polygon.length) {
        case 0:
            return 'Klikk i kartet for å markere område'
        case 1:
        case 2:
            return 'Klikk for å legge til punkt'
        default:
            return 'Klikk på det første punktet for å avslutte området'
    }
}

const AllwaysInBack = (PathComponent) => {
    return class extends PathComponent {
        componentDidMount() {
            super.componentDidMount()
            this.leafletElement.bringToBack()
        }
    }
}

const AllwaysInBackCircleMarker = AllwaysInBack(CircleMarker)

const PolygonSelectionLayer = ({ polygon, firstClicked, mousePosition }) => {
    let markers = polygon.map((p, i) => (
        <CircleMarker
            className={i === 0 ? 'circle first' : 'circle'}
            center={p}
            key={i}
            onClick={i === 0 && polygon.length > 2 ? firstClicked : undefined}
            interactive="true"
        />
    ))

    let cursorPath = null
    let mouseMarker = null
    if (mousePosition) {
        mouseMarker = (
            <AllwaysInBackCircleMarker className="fake-tooltip-marker" interactive={true} center={mousePosition}>
                <Tooltip className="tooltip" permanent={true}>
                    <span>{getStatusText(polygon)}</span>
                </Tooltip>
            </AllwaysInBackCircleMarker>
        )

        if (polygon.length) {
            let cursorPathPositions = [polygon[polygon.length - 1], mousePosition]
            cursorPath = (
                <Polyline
                    className="cursor-path"
                    positions={cursorPathPositions}
                    interactive={false}
                />
            )
        }
    }

    return (
        <LayerGroup>
            {markers && markers.length && (markers.length === 1 ? markers[0] : markers)}
            {polygon && polygon.length && <Polyline className="polyline" positions={polygon} interactive={false} />}
            {polygon && polygon.length && <PolygonLayer polygon={polygon} />}
            {cursorPath}
            {mouseMarker}
        </LayerGroup>
    )
}

export { PolygonLayer, PolygonSelectionLayer }



// WEBPACK FOOTER //
// ./src/felles/Kart/PolygonSelectionLayer.jsx